import { render, staticRenderFns } from "./copy_disk.vue?vue&type=template&id=5ef6c5c2&scoped=true&"
import script from "./copy_disk.vue?vue&type=script&lang=js&"
export * from "./copy_disk.vue?vue&type=script&lang=js&"
import style0 from "./copy_disk.vue?vue&type=style&index=0&id=5ef6c5c2&lang=scss&scoped=true&"
import style1 from "./copy_disk.vue?vue&type=style&index=1&id=5ef6c5c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef6c5c2",
  null
  
)

export default component.exports